/* eslint-disable import/no-anonymous-default-export */
import * as createAction from './createAction'
import * as appActions from './appActions'
import * as localeActions from './localeActions'
import * as errorActions from './errorActions'
import * as navActions from './navActions'
import * as memberActions from './memberActions'
import * as analyticsActions from './analyticsActions'
import * as planActions from './planActions'
import * as applicationActions from './applicationActions'
import * as debugActions from './debugActions'

export default {
  ...createAction,
  ...appActions,
  ...localeActions,
  ...errorActions,
  ...navActions,
  ...memberActions,
  ...planActions,
  ...applicationActions,
  ...analyticsActions,
  ...debugActions
}
